import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../utils/loadable';

const miniCartDueMonthly = Loadable(() =>  import('../FuncContainers/miniCartDueMonthly'));
export default MapTo('vcg/components/soe-home/react/common/miniCartFunctionalDueMonthly')(miniCartDueMonthly);
